module.exports = __webpack_public_path__ + "static/media/whenyouwishuponastar.e5493af7.png";